import React from 'react'
import { Form, InputNumber } from 'antd'
import FormLabel from './FormLabel'

const FormNumberInput = ({width, data, getFieldDecorator, updateLabel, disabled }) => {
  const { label, initialValue, name, info, formatter, parser } = data
  return (
    <Form.Item
      label={<FormLabel label={label} info={info} updateLabel={updateLabel} />}
    >
      {getFieldDecorator(name, {
        initialValue,
      })(
        <InputNumber
          style={{ width: width - 75 }}
          formatter={formatter}
          parser={parser}
          disabled={disabled? disabled: false}
        />
      )}
    </Form.Item>
  )
}
export default FormNumberInput